<footer class="footer-container" data-node-id="1468:33270">
  <!-- Main Footer Content -->
  <div
    class="footer-main"
    [style.background-color]="footerBackgroundColor || null"
    data-node-id="1468:33256"
  >
    <div class="footer-content" data-node-id="1468:33257">
      <!-- Logo -->
      <div class="footer-logo" data-node-id="1468:33258">
        <img *ngIf="logoUrl" [src]="logoUrl" alt="GivingSpace" class="logo-image" />
      </div>

      <!-- Footer Menu -->
      <div class="footer-menu" data-node-id="1468:33259">
        <a [routerLink]="AppRoutes.CONTACT" class="footer-link" data-node-id="1468:33260">
          {{ 'footer.contact_us' | translateLang }}
        </a>
        <a
          [href]="newsLink || null"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          data-node-id="1468:33261"
        >
          {{ 'footer.news' | translateLang }}
        </a>
        <a
          [href]="termsOfUseLink || null"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          data-node-id="1468:33262"
        >
          {{ 'footer.terms_of_use' | translateLang }}
        </a>
        <a
          [href]="privacyPolicyLink || null"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
          data-node-id="1468:33263"
        >
          {{ 'footer.privacy_policy' | translateLang }}
        </a>
      </div>
    </div>
  </div>

  <!-- Copyright Banner -->
  <div
    class="footer-banner"
    [style.background-color]="footerBackgroundColor || null"
    data-node-id="1468:33264"
  >
    <div class="banner-content">
      <p class="copyright-text" data-node-id="1468:33265">
        {{ 'footer.copyright' | translateLang }}
        <a
          [href]="parentWebsiteLink || null"
          target="_blank"
          rel="noopener noreferrer"
          class="organization-link"
          >{{ companyName || ('footer.organization' | translateLang) }}</a
        >
        {{ 'footer.all_rights_reserved' | translateLang }}
      </p>
    </div>
  </div>
</footer>
